import { toast } from "react-toastify";
import api from "../utilities/fetching";
import { authService } from "../services/authService";

export function storeTokenInLocalStorage(token: any) {
  localStorage.removeItem("token");
  localStorage.setItem("token", token);
}

export function getTokenFromLocalStorage() {
  return localStorage.getItem("token");
}

export async function getAuthenticatedUser() {
  const token = getTokenFromLocalStorage();
  if (!token) {
    return { authenticated: false, user: null };
  }

  // Check if the browser is online
  const isOnline = navigator.onLine;

  if (isOnline) {
    // ONLINE: Try to verify with the server
    try {
      const response = await api.get("user");
      console.log(response);
      const user = response?.data?.user;

      if (user) {
        // Verification successful, update the cache with fresh user data
        authService.storeUserInCache(user);
        return { authenticated: true, user: user };
      } else {
        // This case might mean an issue with the server response
        // authService.clearUserCache();
        console.log("User data not found in response, clearing cache.");
        return { authenticated: false, user: null };
      }
    } catch (err: any) {
      // API call failed (e.g., 401 Unauthorized), so the token is invalid.
      // Log the user out completely.
      toast.error("Your session has expired. Please log in again.");
      authService.clearUserCache();
      console.error("Error fetching user data:", err);
      return { authenticated: false, user: null };
    }
  } else {
    // OFFLINE: Trust the local cache
    const cachedUser = authService.getUserFromCache();
    if (cachedUser) {
      // If we are offline but have a user in cache, we trust it.
      return { authenticated: true, user: cachedUser };
    } else {
      // Offline and no user in cache means they are not logged in.
      console.log("Offline and no user in cache, returning unauthenticated.");
      return { authenticated: false, user: null };
    }
  }
}
